import { render, staticRenderFns } from "./user-practice-progress.vue?vue&type=template&id=62d4579e&lang=pug"
import script from "./user-practice-progress.vue?vue&type=script&lang=js"
export * from "./user-practice-progress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports